import { CourseAcademicResults } from 'pages/corporate_reports/CourseAcademicResults';
import { generateResources } from 'utils/GenerateResouces';

const resource = {
  name: 'corporate_reports/course_academic_results',
  route: 'course_academic_results',
  label: 'Resultados Acadêmicos por Curso',
  parentName: 'corporate_reports',
  list: CourseAcademicResults,
  actions: ['list', 'export']
};

export default generateResources(resource);
